import { type Log } from './type';
import { post } from '../network';

/**
 * TO DO: Check profiling
 * @returns
 */
// function getCallerFile () {
//   const originalPrepareStackTrace = Error.prepareStackTrace

//   Error.prepareStackTrace = (_, stack) => stack

//   const err = new Error()
//   const stack = err.stack as unknown as NodeJS.CallSite[]

//   Error.prepareStackTrace = originalPrepareStackTrace

//   // Check the caller file excluding the current module (__filename)
//   for (const frame of stack) {
//     if (frame.getFileName() !== __filename) {
//       return frame.getFileName()
//     }
//   }

//   return null
// }

export class BaseLoggerClass {
  private logs: Log[] = [];
  private readonly size: number; // max size of arr after that push will happen
  private time: number; // interval when flushlogs will be called in SECONDS
  private interval: NodeJS.Timeout | null = null;
  private url: string;
  private active: boolean = false;
  private service: string = '';

  constructor(size: number, time: number, url: string, service: string) {
    this.logs = [];
    this.size = size;
    this.time = time;
    this.url = url;
    this.service = service;

    typeof window !== 'undefined' &&
      window.addEventListener('unload', this.flushLogs.bind(this));
  }

  public getTimeStamp(): number {
    return new Date().getTime();
  }

  public isQueueFull(): boolean {
    if (this.logs?.length >= this.size) {
      return true;
    }
    return false;
  }

  public push(log: Log, immediatePush: boolean = false): void {
    if (!this.canSendLogs()) {
      return;
    }
    this.logs?.push({
      ...log,
      timeStamp: this.getTimeStamp(),
      filePath: log?.filePath !== undefined ? log.filePath : ''
    });

    if (immediatePush || this.isQueueFull()) {
      this.flushLogs();
    }
  }

  public setTime(time: number) {
    this.time = time;
    this.updateInterval();
  }

  public updateInterval() {
    this.interval && clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.flushLogs();
    }, this.time * 1000);
  }

  private beaconAPICall(blob: Blob): void {
    navigator?.sendBeacon?.(this.url, blob);
  }

  private async sendLogsToServer(
    error: Log,
    pathname: string,
    cookies?: string
  ): Promise<void> {
    try {
      const payload = {
        service: this.service,
        log: {
          message: `${error.message} at ${pathname}`,
          level: error.level ?? 'error',
          timeStamp: error.timeStamp ?? Date.now()
        }
      };
      await post('/api/log', {
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Cookie: cookies
        },
        method: 'POST'
      });
    } catch (err) {
      console.error('Error logging to server: ', err);
    }
  }

  public flushLogs(): void {
    if (this.logs?.length === 0 || !this.canSendLogs()) {
      return;
    }
    if (typeof navigator !== 'undefined') {
      const headers = {
        type: 'application/json'
      };

      this.beaconAPICall(
        new Blob(
          [JSON.stringify({ logs: this.logs, service: this.service })],
          headers
        )
      );
    } else {
      this.logs.forEach((log) => {
        void this.sendLogsToServer(
          log,
          log.filePath ?? 'unknown-path',
          log.cookies
        );
      });
    }

    this.logs = [];
  }

  public setURL(url: string): void {
    this.url = url;
  }

  public canSendLogs(): boolean {
    return this.active;
  }

  public activateLogger(service: string) {
    this.service = service;
    this.active = true;
  }

  public deActivateLogger() {
    this.active = false;
  }

  public initializeLogger() {
    this.active = true;
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.flushLogs();
      }, this.time * 1000);
    }
  }

  public getLogs() {
    return this.logs;
  }

  public getSize() {
    return this.size;
  }

  public getActive() {
    return this.active;
  }

  public getInterval() {
    return this.interval;
  }

  public getTime() {
    return this.time;
  }

  public getURL() {
    return this.url;
  }

  public getService() {
    return this.service;
  }

  public setService(service: string) {
    this.service = service;
  }
}
